import { useState, useEffect, useRef } from 'react';
import { playReserveTime } from '../../utilities/sounds';
import './TimeBankBar.css';

const DEFAULT_SECONDS = 30;

// Time-bank progress bar for the seat that is currently to act. Renders inside the
// player bubble (positioned along its bottom edge). Phase 1 is the 30s default bank
// (purple); when it runs out the bar refills and turns red for the reserve bank,
// depleting over the player's remaining reserve seconds. The reserve-start sound is
// played once per turn, and only for the acting user (isHero).
const TimeBankBar = ({ turnStartTime, reserveSeconds = 0, isHero = false }) => {
  const [fill, setFill] = useState(1);          // 0..1 width of the colored bar
  const [inReserve, setInReserve] = useState(false);
  const reserveSoundPlayed = useRef(false);

  useEffect(() => {
    reserveSoundPlayed.current = false;         // re-arm for each new turn
    if (!turnStartTime) return;

    const tick = () => {
      const elapsed = (Date.now() - turnStartTime) / 1000;
      if (elapsed < DEFAULT_SECONDS) {
        setInReserve(false);
        setFill(Math.max(0, (DEFAULT_SECONDS - elapsed) / DEFAULT_SECONDS));
      } else {
        if (!reserveSoundPlayed.current) {
          reserveSoundPlayed.current = true;
          if (isHero) playReserveTime();        // bar just flipped to red
        }
        setInReserve(true);
        const reserveLeft = reserveSeconds - (elapsed - DEFAULT_SECONDS);
        setFill(reserveSeconds > 0 ? Math.max(0, reserveLeft / reserveSeconds) : 0);
      }
    };

    tick();
    const id = setInterval(tick, 100);
    return () => clearInterval(id);
  }, [turnStartTime, reserveSeconds, isHero]);

  return (
    <div className="timebank-bar">
      <div
        className={`timebank-fill ${inReserve ? 'timebank-reserve' : 'timebank-default'}`}
        style={{ width: `${fill * 100}%` }}
      />
    </div>
  );
};

export default TimeBankBar;
